// 小幫手：包一層 fetch，全部沿用 /api/singing_game/* 既有路由
const j = (res) => {
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const getCategories = () => fetch('/api/singing_game/categories').then(j);
export const getRound     = () => fetch('/api/singing_game/round/current').then(j);

export const startRound = (challenger) =>
  fetch('/api/singing_game/round/start', {
    method: 'POST',
    headers: { 'Content-Type':'application/json' },
    body: JSON.stringify({ challenger }),
  }).then(j);

export const selectCategory = (categoryId) =>
  fetch('/api/singing_game/select_category', {
    method: 'POST',
    headers: { 'Content-Type':'application/json' },
    body: JSON.stringify({ categoryId }),
  }).then(j);

export const pickSong = (songId) =>
  fetch('/api/singing_game/pick', {
    method: 'POST',
    headers: { 'Content-Type':'application/json' },
    body: JSON.stringify({ songId }),
  }).then(j);

export const sendAnswer = (pickId, input) =>
  fetch('/api/singing_game/answer', {
    method: 'POST',
    headers: { 'Content-Type':'application/json' },
    body: JSON.stringify({ pickId, input }),
  }).then(j);

export const confirmPick = (pickId) =>
  fetch('/api/singing_game/confirm', {
    method: 'POST',
    headers: { 'Content-Type':'application/json' },
    body: JSON.stringify({ pickId }),
  }).then(j);
